import { useMemo } from 'react';
import { filterTabsByProfile, getInitialTabKey } from '../../../../../../utils/profileTabs';
import { useTabChangeFetch } from '../../../../../../hooks/useTabChangeFetch';
import { MOVIMENTO_TABS } from '../../../shared/constants';

// IMPORT DOS TABS (igual ao form)
import CabecalhoTabPanel from '../../form/tabs/CabecalhoTabPanel';
import BalancoTabPanel from '../../form/tabs/BalancoTabPanel';
import FinanceiroTabPanel from '../../form/tabs/FinanceiroTabPanel';
import RestauranteTabPanel from '../../form/tabs/RestauranteTabPanel';
import ItensTabPanel from '../../form/tabs/ItensTabPanel';
import LancamentoTabPanel from '../../form/tabs/LancamentosTabPanel';
import ObsTabPanel from '../../form/tabs/ObsTabPanel';
import AssinaturasTabPanel from '../../form/tabs/AssinaturasTabPanel';
import FreteTabPanel from '../../form/tabs/FreteTabPanel';
import AditivoTabPanel from '../../form/tabs/AditivoTabPanel';
import ImovelTabPanel from '../../form/tabs/ImovelTabPanel';

export function useMovimentoTabsConfig(ctx) {
    const {
        preFinanceiroBloqueado,
        profile,
        dados,
        operacao,
        parametro,
        operacaoParametros,
        operacaoParametrosDocumentos,
        natureza,
        btnText,

        theme,

        // modules
        balancoModule,
        distribuicaoFiscalModule,
        itensModule,
        assinaturasModule,
        freteModule,
        aditivoModule,

        // states
        parametroPessoa,
        Colaborador,
        Parceiro,
        Administrador,
        ParceiroVinculado,

        OptionsParceiro,
        OptionsParceiroVinculado,
        OptionsColaborador,
        OptionsAdministrador,
        OptionsSituacao,
        OptionsCentroCusto,
        OptionsTabelaPreco,
        OptionsEmpresa,
        OptionsUF,
        OptionsMunicipios,
        OptionsAlmoxarifados,
        OptionsForma,
        OptionsPrazo,
        OptionsConta,
        OptionsSituacaoItem,

        // handlers
        handleChange,
        handleOnFocus,
        handleOnBlur,

        // flags
        isError,
        isLoading,
        isRefetching,

        // MRT
        columnFilterFns,
        columnFilters,
        globalFilter,
        pagination,
        sorting,
        setColumnFilters,
        setColumnFiltersMode,
        setGlobalFilter,
        setPagination,
        setSorting,

        mrtFinanceiro,
        mrtLancamento,

        // extras
        casaDecimal,
        utiliza3digitos,
        formatarNumero,
        formatarNumero3Digitos,

        // perms
        podeIncluir,
        podeEditar,
        podeCancelar,
        podeImprimir,
        podeEditarItem,
        podeCancelarItem,
        podeImprimirItem,

        isDisabledCusto,
        disabledBtnItem,
        limites,
        centroCustoLimiteBloquear,

        enumFreteTipo,
        enumFreteResponsavelFinanceiro,

        //enum de locação
        enumDiaVencimento,
        enumCondominio,
        enumContrato,
        enumEnergia,
        enumAgua,
        enumLocacao,
        enumTipoAditivo,
        enumIPTU,

        navigate,

        handleOpenDialogAssinatura,

        lancamentos,
        rowCountFinanceiro,
        itemLancamentos,
        rowCountLancamento,
        retornaData,

        // pedido padrão
        pedidosPadrao,
        pedidoPadraoLoading,
        onAbrirPedidoPadrao,
        handleSelecionarPedidoPadrao,
        pedidoPadraoSelecionadoUuid,
        handleSalvarPedidoPadrao,
        handleAbrirExcluirPedidoPadrao,
        setFlashMessage,
    } = ctx;

    const tabsConfig = useMemo(() => {
        const isRestaurante = profile?.layout === 'restaurante';

        return [
            // =========================
            // CABEÇALHO
            // =========================
            {
                key: MOVIMENTO_TABS.CABECALHO,
                label: 'Cabeçalho',
                panel: (
                    <CabecalhoTabPanel
                        dados={dados}
                        profile={profile}
                        operacao={operacao}
                        operacaoParametros={operacaoParametros}
                        parametroPessoa={parametroPessoa}
                        btnText={btnText}
                        natureza={natureza}
                        Administrador={Administrador}
                        Colaborador={Colaborador}
                        Parceiro={Parceiro}
                        ParceiroVinculado={ParceiroVinculado}
                        OptionsEmpresa={OptionsEmpresa}
                        OptionsParceiro={OptionsParceiro}
                        OptionsParceiroVinculado={OptionsParceiroVinculado}
                        OptionsColaborador={OptionsColaborador}
                        OptionsAdministrador={OptionsAdministrador}
                        OptionsSituacao={OptionsSituacao}
                        OptionsCentroCusto={OptionsCentroCusto}
                        OptionsUF={OptionsUF}
                        OptionsMunicipios={OptionsMunicipios}
                        OptionsAlmoxarifados={OptionsAlmoxarifados}
                        OptionsForma={OptionsForma}
                        OptionsPrazo={OptionsPrazo}
                        OptionsConta={OptionsConta}
                        enumDiaVencimento={enumDiaVencimento}
                        enumCondominio={enumCondominio}
                        enumContrato={enumContrato}
                        enumEnergia={enumEnergia}
                        enumAgua={enumAgua}
                        enumLocacao={enumLocacao}
                        enumIPTU={enumIPTU}
                        onChange={handleChange}
                        onFocus={handleOnFocus}
                        onBlur={handleOnBlur}
                        pedidoPadraoLoading={pedidoPadraoLoading}
                        pedidosPadrao={pedidosPadrao}
                        onAbrirPedidoPadrao={onAbrirPedidoPadrao}
                        handleSelecionarPedidoPadrao={handleSelecionarPedidoPadrao}
                        pedidoPadraoSelecionadoUuid={pedidoPadraoSelecionadoUuid}
                        handleSalvarPedidoPadrao={handleSalvarPedidoPadrao}
                        handleAbrirExcluirPedidoPadrao={handleAbrirExcluirPedidoPadrao}
                        // distribuição fiscal
                        onAbrirDocumentosFiscais={distribuicaoFiscalModule.actions.abrir}
                        documentosFiscaisLoading={
                            distribuicaoFiscalModule.flags.isLoading || distribuicaoFiscalModule.flags.isRefetching
                        }
                    />
                ),
            },
            // =========================
            // BALANÇO
            // =========================
            {
                key: MOVIMENTO_TABS.BALANCO,
                label: 'Balanço',
                panel: (
                    <BalancoTabPanel
                        theme={theme}
                        module={balancoModule}
                        header={{
                            dados,
                            OptionsAlmoxarifados,
                        }}
                        config={{
                            operacao,
                            profile,
                            parametro,
                            podeEditarItem,
                        }}
                    />
                ),
            },
            // =========================
            // FINANCEIRO
            // =========================
            {
                key: MOVIMENTO_TABS.FINANCEIRO,
                label: 'Financeiro',
                panel: (
                    <FinanceiroTabPanel
                        theme={theme}
                        profile={profile}
                        data={lancamentos ?? []}
                        manual={!!dados?.id}
                        mrt={mrtFinanceiro}
                    />
                ),
            },

            // =========================
            // IMÓVEL
            // =========================
            {
                key: MOVIMENTO_TABS.IMOVEL,
                label: 'Imóvel',
                panel: (
                    <ImovelTabPanel
                        theme={theme}
                        module={itensModule}
                        operacao={operacao}
                        operacaoParametros={operacaoParametros}
                        profile={profile}
                        casaDecimal={casaDecimal}
                        utiliza3digitos={utiliza3digitos}
                        OptionsTabelaPreco={OptionsTabelaPreco}
                        OptionsEmpresa={OptionsEmpresa}
                        OptionsAlmoxarifados={OptionsAlmoxarifados}
                        disabledBtnItem={disabledBtnItem}
                        podeIncluir={podeIncluir}
                        podeEditar={podeEditar}
                        podeCancelar={podeCancelar}
                        podeImprimir={podeImprimir}
                        podeEditarItem={podeEditarItem}
                        podeCancelarItem={podeCancelarItem}
                        podeImprimirItem={podeImprimirItem}
                        setFlashMessage={setFlashMessage}
                    />
                ),
            },

            // =========================
            // ADITIVO
            // =========================
            {
                key: MOVIMENTO_TABS.ADITIVO,
                label: 'Aditivo',
                panel: (
                    <AditivoTabPanel
                        theme={theme}
                        module={aditivoModule}
                        operacao={operacao}
                        operacaoParametrosDocumentos={operacaoParametrosDocumentos}
                        enumTipoAditivo={enumTipoAditivo}
                        podeImprimir={podeImprimir}
                        podeEditarItem={podeEditarItem}
                        podeCancelarItem={podeCancelarItem}
                        navigate={navigate}
                    />
                ),
            },

            // =========================
            // ITENS
            // =========================
            {
                key: MOVIMENTO_TABS.ITENS,
                label: 'Itens',
                panel: isRestaurante ? (
                    <RestauranteTabPanel
                        theme={theme}
                        module={itensModule}
                        header={{
                            dados,
                            Parceiro,
                            Colaborador,
                            OptionsParceiro,
                            OptionsColaborador,
                            OptionsSituacao,
                            OptionsTabelaPreco,
                            onChange: handleChange,
                            onFocus: handleOnFocus,
                            onBlur: handleOnBlur,
                            isDisabledCusto: isDisabledCusto,
                        }}
                        config={{
                            operacao,
                            operacaoParametros,
                            profile,
                            casaDecimal,
                            utiliza3digitos,
                            formatarNumero,
                            formatarNumero3Digitos,
                        }}
                        perms={{
                            disabledBtnItem,
                            podeIncluir,
                            podeEditarItem,
                            podeCancelarItem,
                        }}
                    />
                ) : (
                    <ItensTabPanel
                        theme={theme}
                        module={itensModule}
                        limites={limites}
                        operacao={operacao}
                        parametro={parametro}
                        operacaoParametros={operacaoParametros}
                        profile={profile}
                        casaDecimal={casaDecimal}
                        utiliza3digitos={utiliza3digitos}
                        OptionsTabelaPreco={OptionsTabelaPreco}
                        OptionsEmpresa={OptionsEmpresa}
                        OptionsAlmoxarifados={OptionsAlmoxarifados}
                        OptionsSituacaoItem={OptionsSituacaoItem}
                        divLimite={centroCustoLimiteBloquear}
                        disabledBtnItem={disabledBtnItem}
                        podeIncluir={podeIncluir}
                        podeEditar={podeEditar}
                        podeCancelar={podeCancelar}
                        podeImprimir={podeImprimir}
                        podeEditarItem={podeEditarItem}
                        podeCancelarItem={podeCancelarItem}
                        podeImprimirItem={podeImprimirItem}
                        setFlashMessage={setFlashMessage}
                    />
                ),
            },

            // =========================
            // LANÇAMENTOS (🔥 ESTE ERA O PROBLEMA)
            // =========================
            {
                key: MOVIMENTO_TABS.LANCAMENTO,
                label: 'Lançamentos',
                panel: (
                    <LancamentoTabPanel
                        preFinanceiroBloqueado={preFinanceiroBloqueado}
                        operacaoParametros={operacaoParametros}
                        theme={theme}
                        operacao={operacao}
                        dados={dados}
                        onChange={handleChange}
                        onFocus={handleOnFocus}
                        onBlur={handleOnBlur}
                        OptionsForma={OptionsForma}
                        OptionsPrazo={OptionsPrazo}
                        OptionsConta={OptionsConta}
                        data={itemLancamentos ?? []}
                        mrt={mrtLancamento}
                        manual={!!dados?.id}
                        retornaData={retornaData}
                    />
                ),
            },

            // =========================
            // OBSERVAÇÃO
            // =========================
            {
                key: MOVIMENTO_TABS.OBSERVACAO,
                label: 'Observação',
                panel: (
                    <ObsTabPanel
                        operacao={operacao}
                        profile={profile}
                        dados={dados}
                        handleChange={handleChange}
                        handleOnFocus={handleOnFocus}
                        handleOnBlur={handleOnBlur}
                    />
                ),
            },

            // =========================
            // ASSINATURAS
            // =========================
            {
                key: MOVIMENTO_TABS.ASSINATURA,
                label: 'Assinaturas',
                panel: (
                    <AssinaturasTabPanel
                        theme={theme}
                        module={assinaturasModule}
                        operacao={operacao}
                        onCancelarRow={handleOpenDialogAssinatura}
                        podeCancelarItem={podeCancelarItem}
                    />
                ),
            },

            // =========================
            // FRETE
            // =========================
            {
                key: MOVIMENTO_TABS.FRETE,
                label: 'Frete',
                panel: (
                    <FreteTabPanel
                        theme={theme}
                        module={freteModule}
                        operacao={operacao}
                        casaDecimal={casaDecimal}
                        enumFreteTipo={enumFreteTipo}
                        enumFreteResponsavelFinanceiro={enumFreteResponsavelFinanceiro}
                        OptionsForma={OptionsForma}
                        OptionsPrazo={OptionsPrazo}
                        OptionsConta={OptionsConta}
                        OptionsCentroCusto={OptionsCentroCusto}
                        podeEditarItem={podeEditarItem}
                        podeCancelarItem={podeCancelarItem}
                    />
                ),
            },
        ];
    }, [
        preFinanceiroBloqueado,
        profile,
        dados,
        operacao,
        parametro,
        operacaoParametros,
        balancoModule,
        itensModule,
        assinaturasModule,
        freteModule,
        aditivoModule,
        lancamentos,
        itemLancamentos,
        mrtLancamento,
        mrtFinanceiro,
    ]);

    const tabsConfigFinal = useMemo(() => {
        return filterTabsByProfile(tabsConfig, profile);
    }, [tabsConfig, profile]);

    const initialTabKey = useMemo(() => {
        return getInitialTabKey(profile, {
            defaultKey: 'cabecalho',
            restaurantKey: 'itens',
        });
    }, [profile]);

    const { onTabChange } = useTabChangeFetch({
        initialKey: initialTabKey,
        onChange: async (key) => {
            if (key === 'itens') {
                await itensModule.actions.refresh();
            }

            if (key === 'assinatura') {
                await assinaturasModule.actions.refresh?.();
            }
        },
    });

    return {
        tabsConfigFinal,
        initialTabKey,
        onTabChange,
    };
}
